const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchTaobao ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/tp-taobao-trade-item/search-taobao', { params }).then(res => {
      res.data.list.forEach(item => {
        if (!item.imageUrls && item.pic_url) {
          item.imageUrls = [item.pic_url]
        }
        if (item.title) {
          item.title = item.title.replaceAll(/<span[^>]+>|<\/span>/g, '')
        }
      })
      return res
    })
  },
  viewTaobao ({ state, commit, rootState }, params) {
    params = params.params ? params : { params }
    return rootState.axios.post('/jyb/v1frontend/tp-taobao-trade-item/view-taobao', params.params, params.options)
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/tp-taobao-trade-item/delete', params)
  },
  searchOwn ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/tp-taobao-trade-item/search-own', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
